export default __webpack_public_path__ + "static/media/8-small.34d2edd5.png";